import { Button, ButtonProps } from 'component-library';
import { ReactNode } from 'react';

import { TextContainer } from '../Text/Text';

export type ButtonWidgetProps = {
  text?: string;
  i18nPath?: string;
  children?: ReactNode;
} & ButtonProps;

export const ButtonWidget = ({ text, i18nPath, children, ...props }: ButtonWidgetProps) => {
  return (
    <Button {...props}>
      <TextContainer {...{ text, i18nPath, children }} />
    </Button>
  );
};
